var items = {
  "block.minecraft.air": "vacri",
  "block.minecraft.stone": "rokci",
  "block.minecraft.granite": "rokcrgranu",
  "block.minecraft.polished_granite": "se spali rokcrgranu",
  "block.minecraft.diorite": "rokcrdi'ori",
  "block.minecraft.polished_diorite": "se spali rokcrdi'ori",
  "block.minecraft.andesite": "rokcrande'i",
  "block.minecraft.polished_andesite": "se spali rokcrande'i",
  "block.minecraft.grass_block": "srasu bliku",
  "block.minecraft.dirt": "dertu",
  "block.minecraft.coarse_dirt": "rufsu dertu",
  "block.minecraft.podzol": "dertrpodzo",
  "block.minecraft.crimson_nylium": "zirxu'e ledyclika",
  "block.minecraft.warped_nylium": "cizra ledyclika",
  "block.minecraft.cobblestone": "spirokci",
  "block.minecraft.oak_planks": "cindu mudri tanbo",
  "block.minecraft.spruce_planks": "konku'u mudri tanbo",
  "block.minecraft.birch_planks": ".eptula mudri tanbo",
  "block.minecraft.jungle_planks": "cicricfoi mudri tanbo",
  "block.minecraft.acacia_planks": "atkaciia mudri tanbo",
  "block.minecraft.dark_oak_planks": "mancindu mudri tanbo",
  "block.minecraft.crimson_planks": "zirxu'e tanbo",
  "block.minecraft.warped_planks": "cizra tanbo",
  "block.minecraft.oak_sapling": "cindu ciftricu",
  "block.minecraft.spruce_sapling": "konku'u ciftricu",
  "block.minecraft.birch_sapling": ".eptula ciftricu",
  "block.minecraft.jungle_sapling": "cicricfoi ciftricu",
  "block.minecraft.acacia_sapling": "atkaciia ciftricu",
  "block.minecraft.dark_oak_sapling": "mancindu ciftricu",
  "block.minecraft.bedrock": "cevrokci",
  "block.minecraft.sand": "canre",
  "block.minecraft.red_sand": "xunre canre",
  "block.minecraft.gravel": "rokci canre",
  "block.minecraft.gold_ore": "solji kunra",
  "block.minecraft.iron_ore": "tirse kunra",
  "block.minecraft.coal_ore": "kolme kunra",
  "block.minecraft.nether_gold_ore": "me la .ne'er. solji kunra",
  "block.minecraft.oak_log": "cindu stani",
  "block.minecraft.spruce_log": "konku'u stani",
  "block.minecraft.birch_log": ".eptula stani",
  "block.minecraft.jungle_log": "cicricfoi stani",
  "block.minecraft.acacia_log": ".atkaciia stani",
  "block.minecraft.dark_oak_log": "mancindu stani",
  "block.minecraft.crimson_stem": "zirxu'e stani",
  "block.minecraft.warped_stem": "cizra stani",
  "block.minecraft.stripped_oak_log": "se pilvi'u cindu",
  "block.minecraft.stripped_spruce_log": "se pilvi'u kondu'u",
  "block.minecraft.stripped_birch_log": "se pilvi'u .eptula",
  "block.minecraft.stripped_jungle_log": "se pilvi'u cicricfoi",
  "block.minecraft.stripped_acacia_log": "se pilvi'u .atkaciia",
  "block.minecraft.stripped_dark_oak_log": "se pilvi'u mancindu",
  "block.minecraft.stripped_crimson_stem": "pilcau ke zirxu'e stani",
  "block.minecraft.stripped_warped_stem": "pilcau ke cizra stani",
  "block.minecraft.stripped_oak_wood": "se pilvi'u cindu",
  "block.minecraft.stripped_spruce_wood": "se pilvi'u kondu'u",
  "block.minecraft.stripped_birch_wood": "se pilvi'u .eptula",
  "block.minecraft.stripped_jungle_wood": "se pilvi'u cicricfoimudri",
  "block.minecraft.stripped_acacia_wood": "se pilvi'u .atkaciia",
  "block.minecraft.stripped_dark_oak_wood": "se pilvi'u mancindu",
  "block.minecraft.stripped_crimson_hyphae": "pilcau ke zirxu'e ledju'e",
  "block.minecraft.stripped_warped_hyphae": "pilcau ke cizra ledju'e",
  "block.minecraft.oak_wood": "cindu mudri",
  "block.minecraft.spruce_wood": "konku'u mudri",
  "block.minecraft.birch_wood": ".eptula mudri",
  "block.minecraft.jungle_wood": "cicricfoi mudri",
  "block.minecraft.acacia_wood": "atkaciia mudri",
  "block.minecraft.dark_oak_wood": "mancindu mudri",
  "block.minecraft.crimson_hyphae": "zirxu'e ledju'e",
  "block.minecraft.warped_hyphae": "cizra ledju'e",
  "block.minecraft.oak_leaves": "cindu pezli",
  "block.minecraft.spruce_leaves": "konku'u pezli",
  "block.minecraft.birch_leaves": ".eptula pezli",
  "block.minecraft.jungle_leaves": "cicricfoi pezli",
  "block.minecraft.acacia_leaves": "atkaciia pezli",
  "block.minecraft.dark_oak_leaves": "mancindu pezli",
  "block.minecraft.sponge": "panje",
  "block.minecraft.wet_sponge": "cilmo panje",
  "block.minecraft.glass": "blaci",
  "block.minecraft.lapis_ore": "blaro'i kunra",
  "block.minecraft.lapis_block": "blaro'i bliku",
  "block.minecraft.dispenser": "dudzmi",
  "block.minecraft.sandstone": "canre rokci",
  "block.minecraft.chiseled_sandstone": "se rakpra ke canre rokci",
  "block.minecraft.cut_sandstone": "selka'a canrokci",
  "block.minecraft.note_block": "tonga bliku",
  "block.minecraft.powered_rail": "dikca teltrene",
  "block.minecraft.detector_rail": "ganse teltrene",
  "block.minecraft.sticky_piston": "stali ca'erslanu",
  "block.minecraft.cobweb": "jukyzda",
  "block.minecraft.grass": "srasu",
  "block.minecraft.fern": "filcina",
  "block.minecraft.dead_bush": "morsi demspa",
  "block.minecraft.seagrass": "xasni'asrasu",
  "block.minecraft.sea_pickle": "xasyjirstagi",
  "block.minecraft.piston": "ca'erslanu",
  "block.minecraft.white_wool": "blabi sunla",
  "block.minecraft.orange_wool": "narju sunla",
  "block.minecraft.magenta_wool": "nukni sunla",
  "block.minecraft.light_blue_wool": "labybla sunla",
  "block.minecraft.yellow_wool": "pelxu sunla",
  "block.minecraft.lime_wool": "pelri'o sunla",
  "block.minecraft.pink_wool": "labnukni sunla",
  "block.minecraft.gray_wool": "grusi sunla",
  "block.minecraft.light_gray_wool": "labgrusi sunla",
  "block.minecraft.cyan_wool": "cicna sunla",
  "block.minecraft.purple_wool": "zirpu sunla",
  "block.minecraft.blue_wool": "blanu sunla",
  "block.minecraft.brown_wool": "bunre sunla",
  "block.minecraft.green_wool": "crino sunla",
  "block.minecraft.red_wool": "xunre sunla",
  "block.minecraft.black_wool": "xekri sunla",
  "block.minecraft.dandelion": "spartaraksaku",
  "block.minecraft.poppy": "makpapi",
  "block.minecraft.blue_orchid": "spatrofri",
  "block.minecraft.allium": "citsluni",
  "block.minecraft.azure_bluet": "azure bluet",
  "block.minecraft.red_tulip": "xunre tujli",
  "block.minecraft.orange_tulip": "narju tujli",
  "block.minecraft.white_tulip": "blabi tujli",
  "block.minecraft.pink_tulip": "xunblabi tujli",
  "block.minecraft.oxeye_daisy": "sparbeli",
  "block.minecraft.cornflower": "centaureia",
  "block.minecraft.lily_of_the_valley": "linlani",
  "block.minecraft.wither_rose": "me la .uiter. xrula",
  "block.minecraft.brown_mushroom": "bunre gumri",
  "block.minecraft.red_mushroom": "xunre gumri",
  "block.minecraft.crimson_fungus": "zirxu'e gumri",
  "block.minecraft.warped_fungus": "cizra gumri",
  "block.minecraft.crimson_roots": "zirxu'e genja",
  "block.minecraft.warped_roots": "cizra genja",
  "block.minecraft.nether_sprouts": "dzimu'e cifspa",
  "block.minecraft.weeping_vines": "klaku li'ante",
  "block.minecraft.twisting_vines": "sarlu li'ante",
  "block.minecraft.sugar_cane": "sakta stani",
  "block.minecraft.kelp": "vraike",
  "block.minecraft.bamboo": "bambu",
  "block.minecraft.gold_block": "solji bliku",
  "block.minecraft.iron_block": "tirse bliku",
  "block.minecraft.oak_slab": "cindu xabybli",
  "block.minecraft.spruce_slab": "kondu'u xabybli",
  "block.minecraft.birch_slab": ".eptula xabybli",
  "block.minecraft.jungle_slab": "cicricfoi xabybli",
  "block.minecraft.acacia_slab": ".atkaciia xabybli",
  "block.minecraft.dark_oak_slab": "mancindu xabybli",
  "block.minecraft.crimson_slab": "zirxu'e xabybli",
  "block.minecraft.warped_slab": "cizra xabybli",
  "block.minecraft.stone_slab": "rokci xadba",
  "block.minecraft.smooth_stone_slab": "xutla rokci xabybli",
  "block.minecraft.sandstone_slab": "canre rokci xadba",
  "block.minecraft.cut_sandstone_slab": "cut sandstone slab",
  "block.minecraft.petrified_oak_slab": "se rokygau cindu xabybli",
  "block.minecraft.cobblestone_slab": "spirokci xabybli",
  "block.minecraft.brick_slab": "kitybli xabybli",
  "block.minecraft.stone_brick_slab": "xutla rokci xabybli",
  "block.minecraft.nether_brick_slab": "la me neter. xadba",
  "block.minecraft.quartz_slab": "krili xadba",
  "block.minecraft.red_sandstone_slab": "xunre canre rokci xadba",
  "block.minecraft.cut_red_sandstone_slab": "cut red sandstone slab",
  "block.minecraft.purpur_slab": "purpur xadba",
  "block.minecraft.prismarine_slab": "xabybli be me la prismarin.",
  "block.minecraft.prismarine_brick_slab": "kityxabybli be la prismarin.",
  "block.minecraft.dark_prismarine_slab": "manku xabybli be me la prismarin.",
  "block.minecraft.smooth_quartz": "xutla krilrkartso",
  "block.minecraft.smooth_red_sandstone": "xutla ke xunre canre rokci",
  "block.minecraft.smooth_sandstone": "xutla ke canre rokci",
  "block.minecraft.smooth_stone": "xutla rokci",
  "block.minecraft.bricks": "kitybli",
  "block.minecraft.tnt": "jbama",
  "block.minecraft.bookshelf": "cukta kajna",
  "block.minecraft.mossy_cobblestone": "clika spirokci",
  "block.minecraft.obsidian": "xekyblaci",
  "block.minecraft.torch": "fagytergu'i",
  "block.minecraft.end_rod": ".endre grana",
  "block.minecraft.chorus_plant": "girza'a spati",
  "block.minecraft.chorus_flower": "girza'a xrula",
  "block.minecraft.purpur_block": "purpur bliku",
  "block.minecraft.purpur_pillar": "kamju ke purpur bliku",
  "block.minecraft.purpur_stairs": "purpur serti",
  "block.minecraft.spawner": "bradi mockra",
  "block.minecraft.oak_stairs": "cindu serti",
  "block.minecraft.chest": "vasru",
  "block.minecraft.diamond_ore": "tabjme kunra",
  "block.minecraft.diamond_block": "tabjme bliku",
  "block.minecraft.crafting_table": "zbasu jubme",
  "block.minecraft.farmland": "selcange",
  "block.minecraft.furnace": "zbasu toknu",
  "block.minecraft.ladder": "rajyserti",
  "block.minecraft.rail": "teltrene",
  "block.minecraft.cobblestone_stairs": "spirokci serti",
  "block.minecraft.lever": "vraga",
  "block.minecraft.stone_pressure_plate": "rokci loldi batke",
  "block.minecraft.oak_pressure_plate": "cindu lolbatke",
  "block.minecraft.spruce_pressure_plate": "kondu'u lolbatke",
  "block.minecraft.birch_pressure_plate": ".eptula lolbatke",
  "block.minecraft.jungle_pressure_plate": "cicricfoi lolbatke",
  "block.minecraft.acacia_pressure_plate": ".atkaciia lolbatke",
  "block.minecraft.dark_oak_pressure_plate": "mancindu lolbatke",
  "block.minecraft.crimson_pressure_plate": "zirxu'e danrytapla",
  "block.minecraft.warped_pressure_plate": "cizra danrytapla",
  "block.minecraft.polished_blackstone_pressure_plate": "selspali xekro'i danrytapla",
  "block.minecraft.redstone_ore": "me la redston. kunra",
  "block.minecraft.redstone_torch": "me la redston. fagytergu'i",
  "block.minecraft.snow": "snime",
  "block.minecraft.ice": "bisli",
  "block.minecraft.snow_block": "snime bliku",
  "block.minecraft.cactus": "jesyspa",
  "block.minecraft.clay": "kliti",
  "block.minecraft.jukebox": "zgike bliku",
  "block.minecraft.oak_fence": "cindu garbi'u",
  "block.minecraft.spruce_fence": "konku'u garbi'u",
  "block.minecraft.birch_fence": ".eptula garbi'u",
  "block.minecraft.jungle_fence": "cicricfoi garbi'u",
  "block.minecraft.acacia_fence": "atkaciia garbi'u",
  "block.minecraft.dark_oak_fence": "mancindu garbi'u",
  "block.minecraft.crimson_fence": "zirxu'e garbi'u",
  "block.minecraft.warped_fence": "cizra garbi'u",
  "block.minecraft.pumpkin": "guzmrkukurbita",
  "block.minecraft.carved_pumpkin": "selsraku guzmrkukurbita",
  "block.minecraft.netherrack": "me la neterak.",
  "block.minecraft.soul_sand": "ruxse'i canre",
  "block.minecraft.soul_soil": "pruxi dertu",
  "block.minecraft.basalt": "kamjyro'i",
  "block.minecraft.polished_basalt": "se spali kamjyro'i",
  "block.minecraft.soul_torch": "pruxi fagytergu'i",
  "block.minecraft.glowstone": "carmyro'i",
  "block.minecraft.jack_o_lantern": "selte'a guzmrkukurbita",
  "block.minecraft.oak_trapdoor": "cindu lolvrogai",
  "block.minecraft.spruce_trapdoor": "kondu'u lolvrogai",
  "block.minecraft.birch_trapdoor": ".eptula lolvrogai",
  "block.minecraft.jungle_trapdoor": "cicricfoi lolvrogai",
  "block.minecraft.acacia_trapdoor": ".atkaciia lolvrogai",
  "block.minecraft.dark_oak_trapdoor": "mancindu lolvrogai",
  "block.minecraft.crimson_trapdoor": "zirxu'e lolvrogai",
  "block.minecraft.warped_trapdoor": "cizra lolvrogai",
  "block.minecraft.infested_stone": "cinki rokci",
  "block.minecraft.infested_cobblestone": "spirocki se infeste",
  "block.minecraft.infested_stone_bricks": "cinki ke rokci kitybli",
  "block.minecraft.infested_mossy_stone_bricks": "cinki ke clika rokci kitybli",
  "block.minecraft.infested_cracked_stone_bricks": "cinki ke fenra rokci kitybli",
  "block.minecraft.infested_chiseled_stone_bricks": "cinki ke rakpra rokci kitybli",
  "block.minecraft.stone_bricks": "rokci bliku",
  "block.minecraft.mossy_stone_bricks": "clika ke rokci bliku",
  "block.minecraft.cracked_stone_bricks": "fenra ke rokci bliku",
  "block.minecraft.chiseled_stone_bricks": "rakpra ke rokci bliku",
  "block.minecraft.brown_mushroom_block": "bunre gumri bliku",
  "block.minecraft.red_mushroom_block": "xunre gumri bliku",
  "block.minecraft.mushroom_stem": "gumri stani",
  "block.minecraft.iron_bars": "tirse garna",
  "block.minecraft.chain": ".iinsi",
  "block.minecraft.glass_pane": "canko blaci",
  "block.minecraft.melon": "guzme",
  "block.minecraft.vine": "skospa",
  "block.minecraft.oak_fence_gate": "cindu garbi'u lojvro",
  "block.minecraft.spruce_fence_gate": "konku'u garbi'u lojvro",
  "block.minecraft.birch_fence_gate": ".eptula garbi'u lojvro",
  "block.minecraft.jungle_fence_gate": "cicricfoi garbi'u lojvro",
  "block.minecraft.acacia_fence_gate": "atkaciia garbi'u lojvro",
  "block.minecraft.dark_oak_fence_gate": "mancindu garbi'u lojvro",
  "block.minecraft.crimson_fence_gate": "zirxu'e ke garbi'u vrogai",
  "block.minecraft.warped_fence_gate": "cizra ke garbi'u vrogai",
  "block.minecraft.brick_stairs": "kitybli serti",
  "block.minecraft.stone_brick_stairs": "rokci serti",
  "block.minecraft.mycelium": "mledi",
  "block.minecraft.lily_pad": "nimfaia",
  "block.minecraft.nether_bricks": "blikrne'eri",
  "block.minecraft.cracked_nether_bricks": "selfenra ke dzimu'e kubli bliku",
  "block.minecraft.chiseled_nether_bricks": "selja'i ke dzimu'e kubli bliku",
  "block.minecraft.nether_brick_fence": "la me neter. kitybli garbi'u",
  "block.minecraft.nether_brick_stairs": "la me neter. kitybli serti",
  "block.minecraft.enchanting_table": "makfa jubme",
  "block.minecraft.end_portal_frame": ".endre vorme gerku",
  "block.minecraft.end_stone": ".endre rokci",
  "block.minecraft.end_stone_bricks": ".endre ke rokci bliku",
  "block.minecraft.dragon_egg": "drakono sovda",
  "block.minecraft.redstone_lamp": "me la redston. tergu'i",
  "block.minecraft.sandstone_stairs": "canre rokci serti",
  "block.minecraft.emerald_ore": "ri'ojme kunra",
  "block.minecraft.ender_chest": ".endre vasru",
  "block.minecraft.tripwire_hook": "terkavbu genxu",
  "block.minecraft.emerald_block": "ri'ojme bliku",
  "block.minecraft.spruce_stairs": "konku'u serti",
  "block.minecraft.birch_stairs": ".eptula serti",
  "block.minecraft.jungle_stairs": "cicricfoi serti",
  "block.minecraft.crimson_stairs": "zirxu'e serti",
  "block.minecraft.warped_stairs": "cizra serti",
  "block.minecraft.command_block": "ziltinbe bliku",
  "block.minecraft.beacon": "barda tergu'i",
  "block.minecraft.cobblestone_wall": "spirokci bitmu",
  "block.minecraft.mossy_cobblestone_wall": "clika spirokci bitmu",
  "block.minecraft.brick_wall": "kitybli bitmu",
  "block.minecraft.prismarine_wall": "me la prismarin. bitmu",
  "block.minecraft.red_sandstone_wall": "xunre canro'i bitmu",
  "block.minecraft.mossy_stone_brick_wall": "clika rokci bo bliku bitmu",
  "block.minecraft.granite_wall": "rokcrgranu bitmu",
  "block.minecraft.stone_brick_wall": "stone brick wall",
  "block.minecraft.nether_brick_wall": "la me neter. kitybli bitmu",
  "block.minecraft.andesite_wall": "rokcrande'i bitmu",
  "block.minecraft.red_nether_brick_wall": "xunre me la neter. kitybli bitmu",
  "block.minecraft.sandstone_wall": "canro'i bitmu",
  "block.minecraft.end_stone_brick_wall": ".endre rokci kitybli bitmu",
  "block.minecraft.diorite_wall": "rokcrdi'ori bitmu",
  "block.minecraft.blackstone_wall": "xekro'i bitmu",
  "block.minecraft.polished_blackstone_wall": "selspali xekro'i bitmu",
  "block.minecraft.polished_blackstone_brick_wall": "selspali xekro'i kubli bitmu",
  "block.minecraft.stone_button": "rokci batke",
  "block.minecraft.oak_button": "cindu batke",
  "block.minecraft.spruce_button": "kondu'u batke",
  "block.minecraft.birch_button": ".eptula batke",
  "block.minecraft.jungle_button": "cicricfoi batke",
  "block.minecraft.acacia_button": ".atkaciia batke",
  "block.minecraft.dark_oak_button": "mancindu batke",
  "block.minecraft.crimson_button": "zirxu'e batke",
  "block.minecraft.warped_button": "cizra batke",
  "block.minecraft.polished_blackstone_button": "selspali xekro'i batke",
  "block.minecraft.anvil": "jimda'izbe",
  "block.minecraft.chipped_anvil": "selxai toltce jimda'izbe",
  "block.minecraft.damaged_anvil": "selxai jimda'izbe",
  "block.minecraft.trapped_chest": "terkavbu vasru",
  "block.minecraft.light_weighted_pressure_plate": "light weighted pressure plate",
  "block.minecraft.heavy_weighted_pressure_plate": "heavy weighted pressure plate",
  "block.minecraft.daylight_detector": "daylight detector",
  "block.minecraft.redstone_block": "me la redston. bliku",
  "block.minecraft.nether_quartz_ore": "krilrne'eri kunra",
  "block.minecraft.hopper": "se'arko'u",
  "block.minecraft.chiseled_quartz_block": "se rakpra ke krili bliku",
  "block.minecraft.quartz_block": "krili bliku",
  "block.minecraft.quartz_bricks": "krilrkartso kubli bliku",
  "block.minecraft.quartz_pillar": "kamju krilrkartso",
  "block.minecraft.quartz_stairs": "krili serti",
  "block.minecraft.activator_rail": "actigau garna",
  "block.minecraft.dropper": "falcru",
  "block.minecraft.white_terracotta": "blabi stakrterakota",
  "block.minecraft.orange_terracotta": "narju stakrterakota",
  "block.minecraft.magenta_terracotta": "nukni stakrterakota",
  "block.minecraft.light_blue_terracotta": "labybla stakrterakota",
  "block.minecraft.yellow_terracotta": "pelxu stakrterakota",
  "block.minecraft.lime_terracotta": "pelri'o stakrterakota",
  "block.minecraft.pink_terracotta": "xunblabi stakrterakota",
  "block.minecraft.gray_terracotta": "grusi stakrterakota",
  "block.minecraft.light_gray_terracotta": "labgrusi stakrterakota",
  "block.minecraft.cyan_terracotta": "cicna stakrterakota",
  "block.minecraft.purple_terracotta": "zirpu stakrterakota",
  "block.minecraft.blue_terracotta": "blanu stakrterakota",
  "block.minecraft.brown_terracotta": "bunre stakrterakota",
  "block.minecraft.green_terracotta": "crino stakrterakota",
  "block.minecraft.red_terracotta": "xunre stakrterakota",
  "block.minecraft.black_terracotta": "xekri stakrterakota",
  "block.minecraft.barrier": "zunbi'u",
  "block.minecraft.iron_trapdoor": "tirse lolvrogai",
  "block.minecraft.hay_block": "sudysrasu bakfu",
  "block.minecraft.white_carpet": "blabi buklolgai",
  "block.minecraft.orange_carpet": "narju buklolgai",
  "block.minecraft.magenta_carpet": "nukni buklolgai",
  "block.minecraft.light_blue_carpet": "labybla buklolgai",
  "block.minecraft.yellow_carpet": "pelxu buklolgai",
  "block.minecraft.lime_carpet": "pelri'o buklolgai",
  "block.minecraft.pink_carpet": "kuctai buklolgai",
  "block.minecraft.gray_carpet": "grusi buklolgai",
  "block.minecraft.light_gray_carpet": "labgrusi buklolgai",
  "block.minecraft.cyan_carpet": "cicna buklolgai",
  "block.minecraft.purple_carpet": "zirpu buklolgai",
  "block.minecraft.blue_carpet": "blanu buklolgai",
  "block.minecraft.brown_carpet": "bunre buklolgai",
  "block.minecraft.green_carpet": "crino buklolgai",
  "block.minecraft.red_carpet": "xunre buklolgai",
  "block.minecraft.black_carpet": "xekri buklolgai",
  "block.minecraft.terracotta": "stakrterakota",
  "block.minecraft.coal_block": "kolme bliku",
  "block.minecraft.packed_ice": "demri'a bisli",
  "block.minecraft.acacia_stairs": "atkaciia serti",
  "block.minecraft.dark_oak_stairs": "mancindu serti",
  "block.minecraft.slime_block": "rigdulda'u bliku",
  "block.minecraft.grass_path": "saslu'a",
  "block.minecraft.sunflower": "solspa",
  "block.minecraft.lilac": "tricrsiringa",
  "block.minecraft.rose_bush": "dzitricu rozgu",
  "block.minecraft.peony": "xunblabi xrula",
  "block.minecraft.tall_grass": "rajycra srasu",
  "block.minecraft.large_fern": "barda filcina",
  "block.minecraft.white_stained_glass": "blabi skari blaci",
  "block.minecraft.orange_stained_glass": "narju skari blaci",
  "block.minecraft.magenta_stained_glass": "nukni skari blaci",
  "block.minecraft.light_blue_stained_glass": "labybla skari blaci",
  "block.minecraft.yellow_stained_glass": "pelxu skari blaci",
  "block.minecraft.lime_stained_glass": "pelri'o skari blaci",
  "block.minecraft.pink_stained_glass": "xunblabi skari blaci",
  "block.minecraft.gray_stained_glass": "grusi skari blaci",
  "block.minecraft.light_gray_stained_glass": "labgrusi skari blaci",
  "block.minecraft.cyan_stained_glass": "cicna skari blaci",
  "block.minecraft.purple_stained_glass": "zirpu skari blaci",
  "block.minecraft.blue_stained_glass": "blanu skari blaci",
  "block.minecraft.brown_stained_glass": "bunre skari blaci",
  "block.minecraft.green_stained_glass": "crino skari blaci",
  "block.minecraft.red_stained_glass": "xunre skari blaci",
  "block.minecraft.black_stained_glass": "xekri skari blaci",
  "block.minecraft.white_stained_glass_pane": "blabi skari canko blaci",
  "block.minecraft.orange_stained_glass_pane": "narju skari canko blaci",
  "block.minecraft.magenta_stained_glass_pane": "nukni skari canko blaci",
  "block.minecraft.light_blue_stained_glass_pane": "labybla skari canko blaci",
  "block.minecraft.yellow_stained_glass_pane": "pelxu skari canko blaci",
  "block.minecraft.lime_stained_glass_pane": "pelri'o skari canko blaci",
  "block.minecraft.pink_stained_glass_pane": "kuctai skari canko blaci",
  "block.minecraft.gray_stained_glass_pane": "grusi skari canko blaci",
  "block.minecraft.light_gray_stained_glass_pane": "labgrusi skari canko blaci",
  "block.minecraft.cyan_stained_glass_pane": "cicna skari canko blaci",
  "block.minecraft.purple_stained_glass_pane": "zirpu skari canko blaci",
  "block.minecraft.blue_stained_glass_pane": "blanu skari canko blaci",
  "block.minecraft.brown_stained_glass_pane": "bunre skari canko blaci",
  "block.minecraft.green_stained_glass_pane": "crino skari canko blaci",
  "block.minecraft.red_stained_glass_pane": "xunre skari canko blaci",
  "block.minecraft.black_stained_glass_pane": "xekri skari canko blaci",
  "block.minecraft.prismarine": "me la prismarin.",
  "block.minecraft.prismarine_bricks": "bliku be la prismarin.",
  "block.minecraft.dark_prismarine": "manku be la prismarin.",
  "block.minecraft.prismarine_stairs": "serti be me la prismarin.",
  "block.minecraft.prismarine_brick_stairs": "kitybli serti be la prismarin.",
  "block.minecraft.dark_prismarine_stairs": "manserti be me la prismarin.",
  "block.minecraft.sea_lantern": "xamsi gustci",
  "block.minecraft.red_sandstone": "xunre canre rokci",
  "block.minecraft.chiseled_red_sandstone": "se rakpra ke xunre canre rokci",
  "block.minecraft.cut_red_sandstone": "selka'a xunre canrokci",
  "block.minecraft.red_sandstone_stairs": "xunre canre rokci serti",
  "block.minecraft.repeating_command_block": "rapli ziltinbe bliku",
  "block.minecraft.chain_command_block": ".iinsi ziltinbe bliku",
  "block.minecraft.magma_block": "rumro'i bliku",
  "block.minecraft.nether_wart_block": "me la neter. spati bliku",
  "block.minecraft.warped_wart_block": "cizra malspa bliku",
  "block.minecraft.red_nether_bricks": "la me neter.kitybli co xunre",
  "block.minecraft.bone_block": "bongu bliku",
  "block.minecraft.structure_void": "structure void",
  "block.minecraft.observer": "zgagau",
  "block.minecraft.shulker_box": "tanxe pe la cylkr.",
  "block.minecraft.white_shulker_box": "blabi tanxe pe la cylkr.",
  "block.minecraft.orange_shulker_box": "narju tanxe pe la cylkr.",
  "block.minecraft.magenta_shulker_box": "nukni tanxe pe la cylkr.",
  "block.minecraft.light_blue_shulker_box": "labybla tanxe pe la cylkr.",
  "block.minecraft.yellow_shulker_box": "pelxu tanxe pe la cylkr.",
  "block.minecraft.lime_shulker_box": "pelri'o tanxe pe la cylkr.",
  "block.minecraft.pink_shulker_box": "labnukni tanxe pe la cylkr.",
  "block.minecraft.gray_shulker_box": "grusi tanxe pe la cylkr.",
  "block.minecraft.light_gray_shulker_box": "labgrusi tanxe pe la cylkr.",
  "block.minecraft.cyan_shulker_box": "cicna tanxe pe la cylkr.",
  "block.minecraft.purple_shulker_box": "zirpu tanxe pe la cylkr.",
  "block.minecraft.blue_shulker_box": "blanu tanxe pe la cylkr.",
  "block.minecraft.brown_shulker_box": "bunre tanxe pe la cylkr.",
  "block.minecraft.green_shulker_box": "crino tanxe pe la cylkr.",
  "block.minecraft.red_shulker_box": "xunre tanxe pe la cylkr.",
  "block.minecraft.black_shulker_box": "xekri tanxe pe la cylkr.",
  "block.minecraft.white_glazed_terracotta": "le blabi stakrterakota poi se fagri",
  "block.minecraft.orange_glazed_terracotta": "le narju stakrterakota poi se fagri",
  "block.minecraft.magenta_glazed_terracotta": "le nukni stakrterakota poi jelca",
  "block.minecraft.light_blue_glazed_terracotta": "le labybla stakrterakota poi se fagri",
  "block.minecraft.yellow_glazed_terracotta": "le pelxu stakrterakota poi jelca",
  "block.minecraft.lime_glazed_terracotta": "le pelri'o stakrterakota poi jelca",
  "block.minecraft.pink_glazed_terracotta": "le xunblabi stakrterakota poi se fagri",
  "block.minecraft.gray_glazed_terracotta": "le grusi stakrterakota poi jelca",
  "block.minecraft.light_gray_glazed_terracotta": "le labyrus stakrterakota poi jelca",
  "block.minecraft.cyan_glazed_terracotta": "le cicna stakrterakota poi se fagri",
  "block.minecraft.purple_glazed_terracotta": "le zirpu stakrterakota poi jelca",
  "block.minecraft.blue_glazed_terracotta": "le blabi stakrterakota poi se fagri",
  "block.minecraft.brown_glazed_terracotta": "le bunre stakrterakota poi jelca",
  "block.minecraft.green_glazed_terracotta": "le crino stakrterakota poi se fagri",
  "block.minecraft.red_glazed_terracotta": "le xunre stakrterakota poi jelca",
  "block.minecraft.black_glazed_terracotta": "le xekri stakrterakota poi jelca",
  "block.minecraft.white_concrete": "blabi xumrkonkreto",
  "block.minecraft.orange_concrete": "narju xumrkonkreto",
  "block.minecraft.magenta_concrete": "nukni xumrkonkreto",
  "block.minecraft.light_blue_concrete": "labybla xumrkonkreto",
  "block.minecraft.yellow_concrete": "pelxu xumrkonkreto",
  "block.minecraft.lime_concrete": "pelri'o xumrkonkreto",
  "block.minecraft.pink_concrete": "xunblabi xumrkonkreto",
  "block.minecraft.gray_concrete": "grusi xumrkonkreto",
  "block.minecraft.light_gray_concrete": "labgrusi xumrkonkreto",
  "block.minecraft.cyan_concrete": "cicna xumrkonkreto",
  "block.minecraft.purple_concrete": "zirpu xumrkonkreto",
  "block.minecraft.blue_concrete": "blanu xumrkonkreto",
  "block.minecraft.brown_concrete": "bunre xumrkonkreto",
  "block.minecraft.green_concrete": "crino xumrkonkreto",
  "block.minecraft.red_concrete": "xunre xumrkonkreto",
  "block.minecraft.black_concrete": "xekri xumrkonkreto",
  "block.minecraft.white_concrete_powder": "blabi xumrkonkreto purmo",
  "block.minecraft.orange_concrete_powder": "narju xumrkonkreto purmo",
  "block.minecraft.magenta_concrete_powder": "nukni xumrkonkreto purmo",
  "block.minecraft.light_blue_concrete_powder": "labybla xumrkonkreto purmo",
  "block.minecraft.yellow_concrete_powder": "pelxu xumrkonkreto purmo",
  "block.minecraft.lime_concrete_powder": "pelri'o xumrkonkreto purmo",
  "block.minecraft.pink_concrete_powder": "xunblabi xumrkonkreto purmo",
  "block.minecraft.gray_concrete_powder": "grusi xumrkonkreto purmo",
  "block.minecraft.light_gray_concrete_powder": "labgrusi xumrkonkreto purmo",
  "block.minecraft.cyan_concrete_powder": "cicna xumrkonkreto purmo",
  "block.minecraft.purple_concrete_powder": "zirpu xumrkonkreto purmo",
  "block.minecraft.blue_concrete_powder": "blanu xumrkonkreto purmo",
  "block.minecraft.brown_concrete_powder": "bunre xumrkonkreto purmo",
  "block.minecraft.green_concrete_powder": "crino xumrkonkreto purmo",
  "block.minecraft.red_concrete_powder": "xunre xumrkonkreto purmo",
  "block.minecraft.black_concrete_powder": "xekri xumrkonkreto purmo",
  "block.minecraft.turtle_egg": "cakyrespa sovda",
  "block.minecraft.dead_tube_coral_block": "morsi ke tu'urtai ricnritrina bliku",
  "block.minecraft.dead_brain_coral_block": "morsi ke bentai ricnritrina bliku",
  "block.minecraft.dead_bubble_coral_block": "mrosi ke fomtai ricnritrina bliku",
  "block.minecraft.dead_fire_coral_block": "morsi ke fagtai ricnritrina bliku",
  "block.minecraft.dead_horn_coral_block": "morsi ke jirnytai ricnritrina bliku",
  "block.minecraft.tube_coral_block": "tu'urtai ricnritrina bliku",
  "block.minecraft.brain_coral_block": "bentai ricnritrina bliku",
  "block.minecraft.bubble_coral_block": "fomtai ricnritrina bliku",
  "block.minecraft.fire_coral_block": "fagtai ricnritrina bliku",
  "block.minecraft.horn_coral_block": "jirnytai ricnritrina bliku",
  "block.minecraft.tube_coral": "tu'urtai ricnritrina",
  "block.minecraft.brain_coral": "bentai ricnritrina",
  "block.minecraft.bubble_coral": "fomtai ricnritrina",
  "block.minecraft.fire_coral": "fagtai ricnritrina",
  "block.minecraft.horn_coral": "jirnytai ricnritrina",
  "block.minecraft.dead_brain_coral": "dead brain coral",
  "block.minecraft.dead_bubble_coral": "dead bubble coral",
  "block.minecraft.dead_fire_coral": "dead fire coral",
  "block.minecraft.dead_horn_coral": "dead horn coral",
  "block.minecraft.dead_tube_coral": "dead tube coral",
  "block.minecraft.tube_coral_fan": "tu'urtai ricnritrina tolfalnu",
  "block.minecraft.brain_coral_fan": "bentai ricnritrina tolfalnu",
  "block.minecraft.bubble_coral_fan": "fomtai ricnritrina tolfalnu",
  "block.minecraft.fire_coral_fan": "fagtai ricnritrina tolfalnu",
  "block.minecraft.horn_coral_fan": "jirnytai ricnritrina tolfalnu",
  "block.minecraft.dead_tube_coral_fan": "morsi ke tu'urtai ricnritrina tolfalnu",
  "block.minecraft.dead_brain_coral_fan": "morsi ke bentai ricnritrina tolfalnu",
  "block.minecraft.dead_bubble_coral_fan": "morsi ke fomtai ricnritrina tolfalnu",
  "block.minecraft.dead_fire_coral_fan": "morsi ke fagtai ricnritrina tolfalnu",
  "block.minecraft.dead_horn_coral_fan": "morsi ke jirnytai ricnritrina tolfalnu",
  "block.minecraft.blue_ice": "blanu bisli",
  "block.minecraft.conduit": "xasycei kroxo",
  "block.minecraft.polished_granite_stairs": "se spali rokcrgranu serti",
  "block.minecraft.smooth_red_sandstone_stairs": "xutla xunre bo canro'i serti",
  "block.minecraft.mossy_stone_brick_stairs": "clika rokci bo bliku serti",
  "block.minecraft.polished_diorite_stairs": "se spali rokcrdi'ori serti",
  "block.minecraft.mossy_cobblestone_stairs": "clika spirokci serti",
  "block.minecraft.end_stone_brick_stairs": "ke .endre rokci bliku ke'e serti",
  "block.minecraft.stone_stairs": "rokci serti",
  "block.minecraft.smooth_sandstone_stairs": "xutla canro'i serti",
  "block.minecraft.smooth_quartz_stairs": "xutla krilrkartso serti",
  "block.minecraft.granite_stairs": "rokcrgranu serti",
  "block.minecraft.andesite_stairs": "rokcrande'i serti",
  "block.minecraft.red_nether_brick_stairs": "xunre me la .neter. bo bliku serti",
  "block.minecraft.polished_andesite_stairs": "se spali rokcrande'i serti",
  "block.minecraft.diorite_stairs": "rokcrdi'ori serti",
  "block.minecraft.polished_granite_slab": "se spali rokcrgranu xabybli",
  "block.minecraft.smooth_red_sandstone_slab": "xutla xunre bo canro'i xabybli",
  "block.minecraft.mossy_stone_brick_slab": "clika rokci bo bliku xabybli",
  "block.minecraft.polished_diorite_slab": "se spali rokcrdi'ori xabybli",
  "block.minecraft.mossy_cobblestone_slab": "clika spirokci xabybli",
  "block.minecraft.end_stone_brick_slab": ".endre rokce bo bliku xabybli",
  "block.minecraft.smooth_sandstone_slab": "xutla canro'i xabybli",
  "block.minecraft.smooth_quartz_slab": "xutla krilrkartso xabybli",
  "block.minecraft.granite_slab": "rokcrgranu xabybli",
  "block.minecraft.andesite_slab": "rokcrande'i xabybli",
  "block.minecraft.red_nether_brick_slab": "xunre me la neter. bo bliku xabybli",
  "block.minecraft.polished_andesite_slab": "se spali rokcrande'i xabybli",
  "block.minecraft.diorite_slab": "rokcrdi'ori xabybli",
  "block.minecraft.scaffolding": "tsina",
  "block.minecraft.iron_door": "tirse vrogai",
  "block.minecraft.oak_door": "cindu vrogai",
  "block.minecraft.spruce_door": "konku'u vrogai",
  "block.minecraft.birch_door": ".eptula vrogai",
  "block.minecraft.jungle_door": "cicricfoi vrogai",
  "block.minecraft.acacia_door": "atkaciia vrogai",
  "block.minecraft.dark_oak_door": "mancindu vrogai",
  "block.minecraft.crimson_door": "zirxu'e vrogai",
  "block.minecraft.warped_door": "cizra vrogai",
  "block.minecraft.repeater": "me la redston. bejrapli",
  "block.minecraft.comparator": "me la redston. karbi",
  "block.minecraft.structure_block": "dinju bliku",
  "block.minecraft.jigsaw": "stura kruca bliku",
  "item.minecraft.turtle_helmet": "cakrespa calku□□.i lo stedu zo'u□+2 dabycalku",
  "item.minecraft.scute": "piltapla",
  "item.minecraft.iron_shovel": "tirse canpa□□.i lo ralxa'e zo'u□+3.5 gunta kamtolprali□-3 gunta kamsutra",
  "item.minecraft.iron_pickaxe": "tirse tunymru□□.i lo ralxa'e zo'u□+3 gunta kamtolprali□-2.8 gunta kamsutra",
  "item.minecraft.iron_axe": "tirse ka'amru□□.i lo ralxa'e zo'u□+8 gunta kamtolprali□-3.1 gunta kamsutra",
  "item.minecraft.flint_and_steel": "fagrokci fa'u gasta",
  "item.minecraft.apple": "plise",
  "item.minecraft.bow": "bagyce'a",
  "item.minecraft.arrow": "celga'a",
  "item.minecraft.coal": "kolme",
  "item.minecraft.charcoal": "fagytabno",
  "item.minecraft.diamond": "tabjme",
  "item.minecraft.iron_ingot": "tirse tanbo",
  "item.minecraft.gold_ingot": "solji tanbo",
  "item.minecraft.netherite_ingot": "dzimujyjinme kubli",
  "item.minecraft.netherite_scrap": "dzimujyjinme spisa",
  "item.minecraft.iron_sword": "tirse cladaxi□□.i lo ralxa'e zo'u□+5 gunta kamtolprali□-2.4 gunta kamsutra",
  "item.minecraft.wooden_sword": "mudri cladaxi□□.i lo ralxa'e zo'u□+3 gunta kamtolprali□-2.4 gunta kamsutra",
  "item.minecraft.wooden_shovel": "mudri canpa□□.i lo ralxa'e zo'u□+1.5 gunta kamtolprali□-3 gunta kamsutra",
  "item.minecraft.wooden_pickaxe": "mudri tunymru□□.i lo ralxa'e zo'u□+1 gunta kamtolprali□-2.8 gunta kamsutra",
  "item.minecraft.wooden_axe": "mudri ka'amru□□.i lo ralxa'e zo'u□+6 gunta kamtolprali□-3.2 gunta kamsutra",
  "item.minecraft.stone_sword": "rokci cladaxi□□.i lo ralxa'e zo'u□+4 gunta kamtolprali□-2.4 gunta kamsutra",
  "item.minecraft.stone_shovel": "rokci canpa□□.i lo ralxa'e zo'u□+2.5 gunta kamtolprali□-3 gunta kamsutra",
  "item.minecraft.stone_pickaxe": "rokci tunymru□□.i lo ralxa'e zo'u□+2 gunta kamtolprali□-2.8 gunta kamsutra",
  "item.minecraft.stone_axe": "rokci ka'amru□□.i lo ralxa'e zo'u□+8 gunta kamtolprali□-3.2 gunta kamsutra",
  "item.minecraft.diamond_sword": "tabjme cladaxi□□.i lo ralxa'e zo'u□+6 gunta kamtolprali□-2.4 gunta kamsutra",
  "item.minecraft.diamond_shovel": "tabjme canpa□□.i lo ralxa'e zo'u□+4.5 gunta kamtolprali□-3 gunta kamsutra",
  "item.minecraft.diamond_pickaxe": "tabjme tunymru□□.i lo ralxa'e zo'u□+4 gunta kamtolprali□-2.8 gunta kamsutra",
  "item.minecraft.diamond_axe": "tabjme ka'amru□□.i lo ralxa'e zo'u□+8 gunta kamtolprali□-3 gunta kamsutra",
  "item.minecraft.stick": "grana",
  "item.minecraft.bowl": "kabri",
  "item.minecraft.mushroom_stew": "gumri stasu",
  "item.minecraft.golden_sword": "solji cladaxi□□.i lo ralxa'e zo'u□+3 gunta kamtolprali□-2.4 gunta kamsutra",
  "item.minecraft.golden_shovel": "solji canpa□□.i lo ralxa'e zo'u□+1.5 gunta kamtolprali□-3 gunta kamsutra",
  "item.minecraft.golden_pickaxe": "solji tunymru□□.i lo ralxa'e zo'u□+1 gunta kamtolprali□-2.8 gunta kamsutra",
  "item.minecraft.golden_axe": "solji ka'amru□□.i lo ralxa'e zo'u□+6 gunta kamtolprali□-3 gunta kamsutra",
  "item.minecraft.netherite_sword": "dzimujyjinme cladaxi□□.i lo ralxa'e zo'u□+7 gunta kamtolprali□-2.4 gunta kamsutra",
  "item.minecraft.netherite_shovel": "dzimujyjinme canpa□□.i lo ralxa'e zo'u□+5.5 gunta kamtolprali□-3 gunta kamsutra",
  "item.minecraft.netherite_pickaxe": "dzimujyjinme tunmru□□.i lo ralxa'e zo'u□+5 gunta kamtolprali□-2.8 gunta kamsutra",
  "item.minecraft.netherite_axe": "dzimujyjinme ka'amru□□.i lo ralxa'e zo'u□+9 gunta kamtolprali□-3 gunta kamsutra",
  "item.minecraft.string": "skori",
  "item.minecraft.feather": "pimlu",
  "item.minecraft.gunpowder": "bampu'o",
  "item.minecraft.wooden_hoe": "mudri terplixa□□.i lo ralxa'e zo'u□-3 gunta kamsutra",
  "item.minecraft.stone_hoe": "rokci terplixa□□.i lo ralxa'e zo'u□-2 gunta kamsutra",
  "item.minecraft.iron_hoe": "tirse terplixa□□.i lo ralxa'e zo'u□-1 gunta kamsutra",
  "item.minecraft.diamond_hoe": "tabjme terplixa□□.i lo ralxa'e zo'u",
  "item.minecraft.golden_hoe": "solji terplixa□□.i lo ralxa'e zo'u□-3 gunta kamsutra",
  "item.minecraft.netherite_hoe": "dzimujyjinme lixtci□□.i lo ralxa'e zo'u",
  "item.minecraft.wheat_seeds": "xritsi",
  "item.minecraft.wheat": "maxri",
  "item.minecraft.bread": "nanba",
  "item.minecraft.leather_helmet": "bakskapi mapku□□.i lo stedu zo'u□+1 dabycalku",
  "item.minecraft.leather_chestplate": "bakskapi creka□□.i lo cutne zo'u□+3 dabycalku",
  "item.minecraft.leather_leggings": "bakskapi palku□□.i lo tuple zo'u□+2 dabycalku",
  "item.minecraft.leather_boots": "bakskapi cutci□□.i lo jamfu zo'u□+1 dabycalku",
  "item.minecraft.chainmail_helmet": "linsi badmapku□□.i lo stedu zo'u□+2 dabycalku",
  "item.minecraft.chainmail_chestplate": "linsi badycreka□□.i lo cutne zo'u□+5 dabycalku",
  "item.minecraft.chainmail_leggings": "linsi badypalku□□.i lo tuple zo'u□+4 dabycalku",
  "item.minecraft.chainmail_boots": "linsi badycutci□□.i lo jamfu zo'u□+1 dabycalku",
  "item.minecraft.iron_helmet": "tirse mapku□□.i lo stedu zo'u□+2 dabycalku",
  "item.minecraft.iron_chestplate": "tirse creka□□.i lo cutne zo'u□+6 dabycalku",
  "item.minecraft.iron_leggings": "tirse palku□□.i lo tuple zo'u□+5 dabycalku",
  "item.minecraft.iron_boots": "tirse cutci□□.i lo jamfu zo'u□+2 dabycalku",
  "item.minecraft.diamond_helmet": "tabjme mapku□□.i lo stedu zo'u□+3 dabycalku□+2 badycalku kamtsali",
  "item.minecraft.diamond_chestplate": "tabjme creka□□.i lo cutne zo'u□+8 dabycalku□+2 badycalku kamtsali",
  "item.minecraft.diamond_leggings": "tabjme palku□□.i lo tuple zo'u□+6 dabycalku□+2 badycalku kamtsali",
  "item.minecraft.diamond_boots": "tabjme cutci□□.i lo jamfu zo'u□+3 dabycalku□+2 badycalku kamtsali",
  "item.minecraft.golden_helmet": "solji mapku□□.i lo stedu zo'u□+2 dabycalku",
  "item.minecraft.golden_chestplate": "solji creka□□.i lo cutne zo'u□+5 dabycalku",
  "item.minecraft.golden_leggings": "solji palku□□.i lo tuple zo'u□+3 dabycalku",
  "item.minecraft.golden_boots": "solji cutci□□.i lo jamfu zo'u□+1 dabycalku",
  "item.minecraft.netherite_helmet": "dzimujyjinme mapku□□.i lo stedu zo'u□+3 dabycalku□+3 badycalku kamtsali□+1 nunselgunta muvdu proselkai",
  "item.minecraft.netherite_chestplate": "dzimujyjinme creka□□.i lo cutne zo'u□+8 dabycalku□+3 badycalku kamtsali□+1 nunselgunta muvdu proselkai",
  "item.minecraft.netherite_leggings": "dzimujyjinme palku□□.i lo tuple zo'u□+6 dabycalku□+3 badycalku kamtsali□+1 nunselgunta muvdu proselkai",
  "item.minecraft.netherite_boots": "dzimujyjinme cutci□□.i lo jamfu zo'u□+3 dabycalku□+3 badycalku kamtsali□+1 nunselgunta muvdu proselkai",
  "item.minecraft.flint": "fagro'i",
  "item.minecraft.porkchop": "nalseljukpa xajre'u",
  "item.minecraft.cooked_porkchop": "seljukpa xajre'u",
  "item.minecraft.painting": "pixra",
  "item.minecraft.golden_apple": "solji plise",
  "item.minecraft.enchanted_golden_apple": "selmafyze'a sloplise",
  "block.minecraft.oak_sign": "cindu sinxa",
  "block.minecraft.spruce_sign": "konku'u sinxa",
  "block.minecraft.birch_sign": "bi'orka sinxa",
  "block.minecraft.jungle_sign": "cicricfoi mudri sinxa",
  "block.minecraft.acacia_sign": "atkaciia sinxa",
  "block.minecraft.dark_oak_sign": "mancindu sinxa",
  "block.minecraft.crimson_sign": "zirxu'e lertapla",
  "block.minecraft.warped_sign": "cizra lertapla",
  "item.minecraft.bucket": "baktu",
  "item.minecraft.water_bucket": "djacu baktu",
  "item.minecraft.lava_bucket": "likro'i baktu",
  "item.minecraft.minecart": "baktu trene",
  "item.minecraft.saddle": "danlu seltse",
  "item.minecraft.redstone": "me la redston. pulce",
  "item.minecraft.snowball": "snime bolci",
  "item.minecraft.oak_boat": "cindu bloti",
  "item.minecraft.leather": "bakskapi",
  "item.minecraft.milk_bucket": "ladru baktu",
  "item.minecraft.pufferfish_bucket": "fiprtetraudontidi baktu",
  "item.minecraft.salmon_bucket": "salmone baktu",
  "item.minecraft.cod_bucket": "fiprgadusu baktu",
  "item.minecraft.tropical_fish_bucket": "tropika finpe baktu",
  "item.minecraft.brick": "kitybli",
  "item.minecraft.clay_ball": "kityboi",
  "block.minecraft.dried_kelp_block": "se sudgau vraike bliku",
  "item.minecraft.paper": "pelji",
  "item.minecraft.book": "cukta",
  "item.minecraft.slime_ball": "rigyjdu",
  "item.minecraft.chest_minecart": "baktu trene joi vasru",
  "item.minecraft.furnace_minecart": "baktu trene joi zbasu toknu",
  "item.minecraft.egg": "sovda",
  "item.minecraft.compass": "makfartci",
  "item.minecraft.fishing_rod": "fipkalte grana",
  "item.minecraft.clock": "junla",
  "item.minecraft.glowstone_dust": "carmyro'i pulce",
  "item.minecraft.cod": "fiprgadusu",
  "item.minecraft.salmon": "nalseljukpa salmone",
  "item.minecraft.tropical_fish": "tropika finpe",
  "item.minecraft.pufferfish": "finprtetraodontide",
  "item.minecraft.cooked_cod": "seljukpa fiprgadusu",
  "item.minecraft.cooked_salmon": "seljukpa salmone",
  "item.minecraft.ink_sac": "xinmo dakli",
  "item.minecraft.red_dye": "xunre xinmo",
  "item.minecraft.green_dye": "crino xinmo",
  "item.minecraft.cocoa_beans": "cakla dembi",
  "item.minecraft.lapis_lazuli": "blaro'i",
  "item.minecraft.purple_dye": "zirpu xinmo",
  "item.minecraft.cyan_dye": "cicna xinmo",
  "item.minecraft.light_gray_dye": "labygrusi xinmo",
  "item.minecraft.gray_dye": "grusi xinmo",
  "item.minecraft.pink_dye": "labnukni",
  "item.minecraft.lime_dye": "pelri'o xinmo",
  "item.minecraft.yellow_dye": "pelxu xinmo",
  "item.minecraft.light_blue_dye": "labybla xinmo",
  "item.minecraft.magenta_dye": "nukni xinmo",
  "item.minecraft.orange_dye": "narju xinmo",
  "item.minecraft.bone_meal": "bongu purmo",
  "item.minecraft.blue_dye": "blanu xinmo",
  "item.minecraft.brown_dye": "bunre xinmo",
  "item.minecraft.black_dye": "xekri xinmo",
  "item.minecraft.white_dye": "blabi xinmo",
  "item.minecraft.bone": "bongu",
  "item.minecraft.sugar": "sakta",
  "block.minecraft.cake": "titnanba",
  "block.minecraft.white_bed": "blabi ckana",
  "block.minecraft.orange_bed": "narju ckana",
  "block.minecraft.magenta_bed": "nukni ckana",
  "block.minecraft.light_blue_bed": "labybla ckana",
  "block.minecraft.yellow_bed": "pelxu ckana",
  "block.minecraft.lime_bed": "pelri'o ckana",
  "block.minecraft.pink_bed": "xunblabi ckana",
  "block.minecraft.gray_bed": "grusi ckana",
  "block.minecraft.light_gray_bed": "labgrusi ckana",
  "block.minecraft.cyan_bed": "cicna ckana",
  "block.minecraft.purple_bed": "zirpu ckana",
  "block.minecraft.blue_bed": "blanu ckana",
  "block.minecraft.brown_bed": "bunre ckana",
  "block.minecraft.green_bed": "crino ckana",
  "block.minecraft.red_bed": "xunre ckana",
  "block.minecraft.black_bed": "xekri ckana",
  "item.minecraft.cookie": "cmalu titnanba",
  "item.minecraft.filled_map": "cartu□#0",
  "item.minecraft.shears": "jinci",
  "item.minecraft.melon_slice": "guzme panlo",
  "item.minecraft.dried_kelp": "se sudgau vraike",
  "item.minecraft.pumpkin_seeds": "guzmrkukurbita tsiju",
  "item.minecraft.melon_seeds": "guzme tsiju",
  "item.minecraft.beef": "nalseljukpa bakyre'u",
  "item.minecraft.cooked_beef": "seljukpa bakyre'u",
  "item.minecraft.chicken": "nalseljukpa jipcyre'u",
  "item.minecraft.cooked_chicken": "seljukpa jipcyre'u",
  "item.minecraft.rotten_flesh": "fusra rectu",
  "item.minecraft.ender_pearl": ".endre boijme",
  "item.minecraft.blaze_rod": "fagri grana",
  "item.minecraft.ghast_tear": "la me gast. kalselvi'i",
  "item.minecraft.gold_nugget": "solji spisa",
  "item.minecraft.nether_wart": "me la neter. spati",
  "item.minecraft.potion": "nalzbaka'e mafsodva□no da galfi",
  "item.minecraft.glass_bottle": "blaci botpi",
  "item.minecraft.spider_eye": "jukni kanla",
  "item.minecraft.fermented_spider_eye": "fusra ke jukni kanla",
  "item.minecraft.blaze_powder": "fagri purmo",
  "item.minecraft.magma_cream": "likro'i kruji",
  "block.minecraft.brewing_stand": "selpinxe jukpa jubme",
  "block.minecraft.cauldron": "patxu",
  "item.minecraft.ender_eye": ".endre kanla",
  "item.minecraft.glistering_melon_slice": "mircai zmepa'o",
  "item.minecraft.bat_spawn_egg": "volratcu jbeso'a",
  "item.minecraft.bee_spawn_egg": "bifce jbeso'a",
  "item.minecraft.blaze_spawn_egg": "fagda'u jbeso'a",
  "item.minecraft.cat_spawn_egg": "mlatu jbeso'a",
  "item.minecraft.cave_spider_spawn_egg": "kevjukni jbeso'a",
  "item.minecraft.chicken_spawn_egg": "jipci jbeso'a",
  "item.minecraft.cod_spawn_egg": "fiprgadusu jbeso'a",
  "item.minecraft.cow_spawn_egg": "bakni jbeso'a",
  "item.minecraft.creeper_spawn_egg": "jbeso'a be la kriper.",
  "item.minecraft.dolphin_spawn_egg": "delfinu jbeso'a",
  "item.minecraft.donkey_spawn_egg": "xasli jbeso'a",
  "item.minecraft.drowned_spawn_egg": "jaurvau mivymro jbeso'a",
  "item.minecraft.elder_guardian_spawn_egg": "dzebadypre jbeso'a",
  "item.minecraft.enderman_spawn_egg": ".endre prenu jbeso'a",
  "item.minecraft.endermite_spawn_egg": ".endre miptera jbeso'a",
  "item.minecraft.evoker_spawn_egg": "pacykemklacpepre jbeso'a",
  "item.minecraft.fox_spawn_egg": "lorxu jbeso'a",
  "item.minecraft.ghast_spawn_egg": "jbeso'a be la gast.",
  "item.minecraft.guardian_spawn_egg": "badypre jbeso'a",
  "item.minecraft.hoglin_spawn_egg": "balxarju jbeso'a",
  "item.minecraft.horse_spawn_egg": "xirma jbeso'a",
  "item.minecraft.husk_spawn_egg": "sudga mivymro jbeso'a",
  "item.minecraft.llama_spawn_egg": "tcokumte jbeso'a",
  "item.minecraft.magma_cube_spawn_egg": "likrokybli jbeso'a",
  "item.minecraft.mooshroom_spawn_egg": "bakygumri jbeso'a",
  "item.minecraft.mule_spawn_egg": "xaslyxi'a jbeso'a",
  "item.minecraft.ocelot_spawn_egg": "cicmlatu jbeso'a",
  "item.minecraft.panda_spawn_egg": "latcribe jbeso'a",
  "item.minecraft.parrot_spawn_egg": "spitaki jbeso'a",
  "item.minecraft.phantom_spawn_egg": "cteru'i jbeso'a",
  "item.minecraft.pig_spawn_egg": "xarju jbeso'a",
  "item.minecraft.piglin_spawn_egg": "xajypre jbeso'a",
  "item.minecraft.pillager_spawn_egg": "vilcpapre jbeso'a",
  "item.minecraft.polar_bear_spawn_egg": "bercribe jbeso'a",
  "item.minecraft.pufferfish_spawn_egg": "fiprtetraudontidi jbeso'a",
  "item.minecraft.rabbit_spawn_egg": "ratcu jbeso'a",
  "item.minecraft.ravager_spawn_egg": "nunspokezgau jbeso'a",
  "item.minecraft.salmon_spawn_egg": "salmone jbeso'a",
  "item.minecraft.sheep_spawn_egg": "lanme jbeso'a",
  "item.minecraft.shulker_spawn_egg": "jbeso'a be la cylkr.",
  "item.minecraft.silverfish_spawn_egg": "selmipyda'u jbeso'a",
  "item.minecraft.skeleton_spawn_egg": "bogygreku jbeso'a",
  "item.minecraft.skeleton_horse_spawn_egg": "bogrekyxirma jbeso'a",
  "item.minecraft.slime_spawn_egg": "rigdulda'u jbeso'a",
  "item.minecraft.spider_spawn_egg": "jukni jbeso'a",
  "item.minecraft.squid_spawn_egg": "kalmari jbeso'a",
  "item.minecraft.stray_spawn_egg": "muvzva jbeso'a",
  "item.minecraft.strider_spawn_egg": "fagdzu jbeso'a",
  "item.minecraft.trader_llama_spawn_egg": "trader llama spawn egg",
  "item.minecraft.tropical_fish_spawn_egg": "tropika finpe jbeso'a",
  "item.minecraft.turtle_spawn_egg": "cakrespa jbeso'a",
  "item.minecraft.vex_spawn_egg": "cmapalci jbeso'a",
  "item.minecraft.villager_spawn_egg": "selsosyzda jbeso'a",
  "item.minecraft.vindicator_spawn_egg": "pacybandu jbeso'a",
  "item.minecraft.wandering_trader_spawn_egg": "wandering trader spawn egg",
  "item.minecraft.witch_spawn_egg": "termafyfe'i jbeso'a",
  "item.minecraft.wither_skeleton_spawn_egg": "me la .uiter. bogygreku jbeso'a",
  "item.minecraft.wolf_spawn_egg": "labno jbeso'a",
  "item.minecraft.zoglin_spawn_egg": "mivmro balxarju jbeso'a",
  "item.minecraft.zombie_spawn_egg": "mivymro jbeso'a",
  "item.minecraft.zombie_horse_spawn_egg": "mivymroxirma jbeso'a",
  "item.minecraft.zombie_villager_spawn_egg": "mivymro selsosyzda jbeso'a",
  "item.minecraft.zombified_piglin_spawn_egg": "mivmro xajypre jbeso'a",
  "item.minecraft.experience_bottle": "makfa botpi",
  "item.minecraft.fire_charge": "mafselfagri",
  "item.minecraft.writable_book": "penbi joi cukta",
  "item.minecraft.written_book": "fanmo cukta",
  "item.minecraft.emerald": "ri'ojme",
  "item.minecraft.item_frame": "ja'ordai greku",
  "block.minecraft.flower_pot": "patxu xrula",
  "item.minecraft.carrot": "najgenja",
  "item.minecraft.potato": "patlu",
  "item.minecraft.baked_potato": "seljukpa patlu",
  "item.minecraft.poisonous_potato": "vindu patla",
  "item.minecraft.map": "kunti cartu",
  "item.minecraft.golden_carrot": "solji najgenja",
  "block.minecraft.skeleton_skull": "bogygreku sedbo'u",
  "block.minecraft.wither_skeleton_skull": "la me witer. je stedu",
  "block.minecraft.player_head": "stedu be lo kelci",
  "block.minecraft.zombie_head": "mivymro stedu",
  "block.minecraft.creeper_head": "stedu be la .kripr.",
  "block.minecraft.dragon_head": "lo stedu be lo drakono",
  "item.minecraft.carrot_on_a_stick": "najgenja co jorne be lo grana",
  "item.minecraft.warped_fungus_on_a_stick": "cizra bo gumri joi grana",
  "item.minecraft.nether_star": "la me neter. tarci",
  "item.minecraft.pumpkin_pie": "guzmrkukurbita nabypalne",
  "item.minecraft.firework_rocket": "mlefagri jakne",
  "item.minecraft.firework_star": "spoja tarmi fa",
  "item.minecraft.enchanted_book": "mafcku",
  "item.minecraft.nether_brick": "la me neter. kitybli",
  "item.minecraft.quartz": "krilrne'eri",
  "item.minecraft.tnt_minecart": "baktu trene joi jbama",
  "item.minecraft.hopper_minecart": "baktu trene joi se'arko'u",
  "item.minecraft.prismarine_shard": "selpo'i me la prismarin.",
  "item.minecraft.prismarine_crystals": "prismarine crystals",
  "item.minecraft.rabbit": "nalseljukpa ractu",
  "item.minecraft.cooked_rabbit": "seljukpa ractu",
  "item.minecraft.rabbit_stew": "ractu stasu",
  "item.minecraft.rabbit_foot": "jamfu be lo ractu",
  "item.minecraft.rabbit_hide": "skapi be lo ractu",
  "item.minecraft.armor_stand": "badycakyzbe",
  "item.minecraft.iron_horse_armor": "tirse xirbadycalku",
  "item.minecraft.golden_horse_armor": "solji xirbadycalku",
  "item.minecraft.diamond_horse_armor": "tabjme xirbadycalku",
  "item.minecraft.leather_horse_armor": "bakskapi ke xirma dabycalku",
  "item.minecraft.lead": "velxlu",
  "item.minecraft.name_tag": "cmene tcita",
  "item.minecraft.command_block_minecart": "baktu trene joi ziltinbe bliku",
  "item.minecraft.mutton": "nalseljukpa lanr'eu",
  "item.minecraft.cooked_mutton": "seljukpa lanre'u",
  "block.minecraft.white_banner": "blabi srilanci",
  "block.minecraft.orange_banner": "narju srilanci",
  "block.minecraft.magenta_banner": "nukni srilanci",
  "block.minecraft.light_blue_banner": "labybla srilanci",
  "block.minecraft.yellow_banner": "pelxu srilanci",
  "block.minecraft.lime_banner": "pelri'o srilanci",
  "block.minecraft.pink_banner": "kuctai srilanci",
  "block.minecraft.gray_banner": "grusi srilanci",
  "block.minecraft.light_gray_banner": "labgrusi srilanci",
  "block.minecraft.cyan_banner": "cicna srilanci",
  "block.minecraft.purple_banner": "zirpu srilanci",
  "block.minecraft.blue_banner": "blanu srilancu",
  "block.minecraft.brown_banner": "bunre srilanci",
  "block.minecraft.green_banner": "crino srilanci",
  "block.minecraft.red_banner": "xukmi srilanci",
  "block.minecraft.black_banner": "xekri srilanci",
  "item.minecraft.end_crystal": ".endre krili",
  "item.minecraft.chorus_fruit": "girza'a grute",
  "item.minecraft.popped_chorus_fruit": "selpo'i girza'a grute",
  "item.minecraft.beetroot": "spatrtensai",
  "item.minecraft.beetroot_seeds": "spatrtensai tsiju",
  "item.minecraft.beetroot_soup": "spatrtensai stasu",
  "item.minecraft.dragon_breath": "drakono selva'u",
  "item.minecraft.splash_potion": "nalzbaka'e ke selre'o mafsodva□no da galfi",
  "item.minecraft.spectral_arrow": "spectral arrow",
  "item.minecraft.tipped_arrow": "uncraftable tipped arrow□no da galfi",
  "item.minecraft.lingering_potion": "lingering uncraftable potion□no da galfi",
  "item.minecraft.shield": "badgai",
  "item.minecraft.elytra": "na'irnelitrono",
  "item.minecraft.spruce_boat": "konku'u bloti",
  "item.minecraft.birch_boat": ".eptula bloti",
  "item.minecraft.jungle_boat": "cicricfoi bloti",
  "item.minecraft.acacia_boat": "atkaciia bloti",
  "item.minecraft.dark_oak_boat": "mancindu bloti",
  "item.minecraft.totem_of_undying": "nalmro nindode",
  "item.minecraft.shulker_shell": "calku pe la cylkr.",
  "item.minecraft.iron_nugget": "tirse spisa",
  "item.minecraft.knowledge_book": "selju'o cukta",
  "item.minecraft.debug_stick": "gafygaurga'a",
  "item.minecraft.music_disc_13": "zgike vreji□c418 - 13",
  "item.minecraft.music_disc_cat": "zgike vreji□c418 - cat",
  "item.minecraft.music_disc_blocks": "zgike vreji□c418 - blocks",
  "item.minecraft.music_disc_chirp": "zgike vreji□c418 - chirp",
  "item.minecraft.music_disc_far": "zgike vreji□c418 - far",
  "item.minecraft.music_disc_mall": "zgike vreji□c418 - mall",
  "item.minecraft.music_disc_mellohi": "zgike vreji□c418 - mellohi",
  "item.minecraft.music_disc_stal": "zgike vreji□c418 - stal",
  "item.minecraft.music_disc_strad": "zgike vreji□c418 - strad",
  "item.minecraft.music_disc_ward": "zgike vreji□c418 - ward",
  "item.minecraft.music_disc_11": "zgike vreji□c418 - 11",
  "item.minecraft.music_disc_wait": "zgike vreji□c418 - wait",
  "item.minecraft.music_disc_pigstep": "zgike vreji□lena raine - pigstep",
  "item.minecraft.trident": "cibyba'erxa'i□□.i lo ralxa'e zo'u□+8 gunta kamtolprali□-2.9 gunta kamsutra",
  "item.minecraft.phantom_membrane": "cteru'i nalci",
  "item.minecraft.nautilus_shell": "cakrnotilodi",
  "item.minecraft.heart_of_the_sea": "xasrisna",
  "item.minecraft.crossbow": "seljicyce'a",
  "item.minecraft.suspicious_stew": "suspicious stew",
  "block.minecraft.loom": "bukyzbami'i",
  "item.minecraft.flower_banner_pattern": "terlanci□xrula tarmi",
  "item.minecraft.creeper_banner_pattern": "terlanci□ri'orfrupo'a flira",
  "item.minecraft.skull_banner_pattern": "terlanci□sedbo'u tarmi",
  "item.minecraft.mojang_banner_pattern": "terlanci□zo'e",
  "item.minecraft.globe_banner_pattern": "terlanci□boltai",
  "item.minecraft.piglin_banner_pattern": "terlanci□xajyzbi",
  "block.minecraft.composter": "rikfre pulce ke fusra minji",
  "block.minecraft.barrel": "mudbaktu",
  "block.minecraft.smoker": "damtoknu",
  "block.minecraft.blast_furnace": "baltoknu",
  "block.minecraft.cartography_table": "catplajbu",
  "block.minecraft.fletching_table": "celga'azbajbu",
  "block.minecraft.grindstone": "zalxi'u",
  "block.minecraft.lectern": "nunctuta'a jubme",
  "block.minecraft.smithing_table": "tcizbajbu",
  "block.minecraft.stonecutter": "rokyka'armi'i",
  "block.minecraft.bell": "janbe",
  "block.minecraft.lantern": "lanru",
  "block.minecraft.soul_lantern": "pruxi dadytergu'i",
  "item.minecraft.sweet_berries": "titla jbari",
  "block.minecraft.campfire": "gikyfagri",
  "block.minecraft.soul_campfire": "pruxi gikfagri",
  "block.minecraft.shroomlight": "ledytergu'i",
  "item.minecraft.honeycomb": "biclakse",
  "block.minecraft.bee_nest": "bifce zdani",
  "block.minecraft.beehive": "rutni bicyzda",
  "item.minecraft.honey_bottle": "melmybo'i",
  "block.minecraft.honey_block": "melmi bliku",
  "block.minecraft.honeycomb_block": "biclakse bliku",
  "block.minecraft.lodestone": "maksi",
  "block.minecraft.netherite_block": "dzimujyjinme bliku",
  "block.minecraft.ancient_debris": "tcepru spisa",
  "block.minecraft.target": "teryre'o",
  "block.minecraft.crying_obsidian": "klaku xekyblaci",
  "block.minecraft.blackstone": "xekro'i",
  "block.minecraft.blackstone_slab": "xekro'i xabybli",
  "block.minecraft.blackstone_stairs": "xekro'i serti",
  "block.minecraft.gilded_blackstone": "slovau xekro'i",
  "block.minecraft.polished_blackstone": "selspali xekro'i",
  "block.minecraft.polished_blackstone_slab": "selspali xekro'i xabybli",
  "block.minecraft.polished_blackstone_stairs": "selspali xekro'i serti",
  "block.minecraft.chiseled_polished_blackstone": "selja'i ke selspali xekro'i",
  "block.minecraft.polished_blackstone_bricks": "selspali xekro'i kubli bliku",
  "block.minecraft.polished_blackstone_brick_slab": "selspali xekro'i kubli xabybli",
  "block.minecraft.polished_blackstone_brick_stairs": "selspali xekro'i kubli serti",
  "block.minecraft.cracked_polished_blackstone_bricks": "selfenra ke selspali xekro'i kubli bliku",
  "block.minecraft.respawn_anchor": "rapyjbe tutci",
}
export const jbo_en = items; 
